export const SHIFT_ROUTE_NAMES = {
    MAIN: "ShiftMain",
};
